import { FC } from 'react';
import styled from 'styled-components';

interface ModalDropdownProps {
	header: string;
	content: JSX.Element;
}

const ModalBlockContainerStyled = styled.div`
	padding: 16px 24px;
	border: 1px solid #f5f5f5;
	border-radius: 8px;
	background-color: #fafafa;
`;

const ModalBlockHeaderStyled = styled.h3`
	font-weight: 400;
	font-size: 16px;
`;

const ModalBlockContentContainerStyled = styled.div``;

export const ModalDropdown: FC<ModalDropdownProps> = ({ header, content }) => (
	<ModalBlockContainerStyled>
		<ModalBlockHeaderStyled>{header}</ModalBlockHeaderStyled>
		<ModalBlockContentContainerStyled>{content}</ModalBlockContentContainerStyled>
	</ModalBlockContainerStyled>
);
